"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base64Encode_1 = __importDefault(require("./base64Encode"));
const getType = (value) => {
    if (typeof value === "string") {
        return "string";
    }
    if (typeof value === "number") {
        if (Number.isInteger(value)) {
            return "int";
        }
        return "double";
    }
    return "bool";
};
class Context {
    constructor(contexts) {
        if (!Object.values(contexts).every((item) => typeof item === "object")) {
            // eslint-disable-next-line no-console
            console.error("Context must be an object where the value of each key is also an object");
        }
        if (Object.values(contexts).some((item) => Object.values(item).some((value) => typeof value === "object" && value !== null))) {
            // we decided to allow null values, which requres an extra check since typeof null is object
            // eslint-disable-next-line no-console
            console.error("Nested objects are not supported in context values at this time");
        }
        this.contexts = contexts;
    }
    encode() {
        const formatted = Object.keys(this.contexts).map((key) => {
            const values = {};
            Object.keys(this.contexts[key]).forEach((ckey) => {
                values[ckey] = {
                    [getType(this.contexts[key][ckey])]: this.contexts[key][ckey],
                };
            });
            return {
                type: key,
                values,
            };
        });
        return encodeURIComponent((0, base64Encode_1.default)(JSON.stringify({ contexts: formatted })));
    }
}
exports.default = Context;
